import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-d95755d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "table-chip"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "4",
  cy: "4",
  r: "4",
  fill: "#F3E7AB"
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "data-segment": 1,
  class: "pi pi-ellipsis-v"
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "sub-table-container" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sub-table-heading" }, "Список сегментов", -1))
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "4",
  cy: "4",
  r: "4",
  fill: "#F3E7AB"
}, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "data-segment": 1,
  class: "pi pi-ellipsis-v"
}, null, -1))
const _hoisted_19 = [
  _hoisted_18
]

import { ref, computed } from "vue";

import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Menu from "primevue/menu";
import DeleteConfirmDialog from "@/shared/dialogs/DeleteConfirmDialog.vue";
import ArchiveConfirmDialog from "@/shared/dialogs/ArchiveConfirmDialog.vue";
import PlatformChip from "@/shared/chips/PlatformChip.vue";
import ListWithTooltips from "@/entities/segments/table/ListWithTooltips.vue";
import UsersHistoryDialog from "@/widgets/dialogs/UsersHistoryDialog.vue";

import {
  convertDateFromUTC,
  convertDateFromISOWithShortYear,
} from "@/services/utils/DateParser";
import { getUserName } from "@/services/utils/Names";
import { useCampaignStore, Campaign } from "@/store/campaigns/campaigns";
import { useCampaignsDictionariesStore } from "@/store/dictionaries/campaigns";
import { useRouter } from "vue-router";
import { rootGetters } from "@/main";
import { formatNumber } from "@/services/utils/Strings";
import { useAuthStore } from "@/store/auth/login";


export default /*#__PURE__*/_defineComponent({
  __name: 'CampaignsTable',
  props: {
    campaigns: {},
    isArchiveEnabled: { type: Boolean },
    isActiveFirst: { type: Boolean },
    isLoading: { type: Boolean },
    rowsCount: {}
  },
  emits: ["sortTable", "updateTable"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;
const campaignsStore = useCampaignStore();
const campaignsDictionariesStore = useCampaignsDictionariesStore();
const router = useRouter();
const authStore = useAuthStore();

let modifiedId = ref(0);
let modifiedEntity = ref("campaigns");
const confirmVisible = ref({
  delete: false,
  archive: false,
  history: false,
});
const blockedButton = ref({
  delete: false,
  archive: false,
});
const menu = ref();
const menuSegments = ref();
const expandedRows = ref({});

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions(["history:edit"], ["history:read"]);
});

const items = ref([
  {
    label: "История действий",
    icon: "pi pi-history",
    checkDenied: true,
    archive: "both",
    command: () => {
      confirmVisible.value.history = true;
    },
  },
  {
    label: "Редактировать",
    icon: "pi pi-pencil",
    checkDenied: false,
    archive: "no_archive",
    command: () => {
      router.push({ name: "campaign", params: { id: modifiedId.value } });
    },
  },
  {
    label: "Архивировать",
    icon: "pi pi-inbox",
    checkDenied: false,
    archive: "no_archive",
    command: () => {
      confirmVisible.value.archive = true;
    },
  },
  {
    label: "Разархивировать",
    icon: "pi pi-inbox",
    checkDenied: false,
    archive: "archive",
    command: () => {
      campaignsStore.unArchiveCampaign(modifiedId.value).then(() => {
        emits("updateTable");
      });
    },
  },
  {
    label: "Дублировать",
    icon: "pi pi-copy",
    checkDenied: false,
    archive: "no_archive",
    command: () => {
      campaignsStore.duplicateCampaignId = modifiedId.value;
      router.push({ name: "campaignCreate" });
    },
  },
  {
    label: "Удалить",
    icon: "pi pi-trash",
    checkDenied: false,
    archive: "both",
    command: () => {
      confirmVisible.value.delete = true;
    },
  },
]);

const segmentsItems = ref([
  {
    label: "История действий",
    icon: "pi pi-history",
    checkDenied: true,
    archive: "both",
    command: () => {
      confirmVisible.value.history = true;
    },
  },
]);

const filteredItems = computed(() => {
  const itemsDenied = items.value.filter(
    (item) => !(item.checkDenied && isDenied.value)
  );
  return itemsDenied.filter((item) =>
    props.isArchiveEnabled
      ? ["both", "archive"].includes(item.archive)
      : ["both", "no_archive"].includes(item.archive)
  );
});

const filteredSegmentsItems = computed(() => {
  return segmentsItems.value.filter(
    (item) => !(item.checkDenied && isDenied.value)
  );
});

const toggle = (segmentId: number, event: any) => {
  modifiedId.value = segmentId;
  modifiedEntity.value = "campaigns";
  menu.value.toggle(event);
};

const toggleSegments = (segmentId: number, event: any) => {
  modifiedId.value = segmentId;
  modifiedEntity.value = "campaign_segments";
  menuSegments.value.toggle(event);
};

const deleteCampaign = () => {
  blockedButton.value.delete = true;
  campaignsStore
    .deleteCampaign(modifiedId.value)
    .finally(() => {
      emits("updateTable");
      blockedButton.value.delete = false;
      confirmVisible.value.delete = false;
    })
    .catch((err) => {
      if (err.response && err.response.status == 400)
        rootGetters.toast.show("warn", "Ошибка", err.response.data.detail);
    });
};

const archiveCampaign = () => {
  blockedButton.value.archive = true;
  campaignsStore.archiveCampaign(modifiedId.value).finally(() => {
    emits("updateTable");
    blockedButton.value.archive = false;
    confirmVisible.value.archive = false;
  });
};

const sortTable = (event: any) => {
  let orderField = "";
  if (event.sortField)
    orderField = event.sortOrder > 0 ? event.sortField : `-${event.sortField}`;
  emits("sortTable", orderField);
};

const getSources = (data: any) => {
  const sources: string[] = [];
  data.campaign_cabinets.forEach((element: any) => {
    if (!sources.includes(element.source.name))
      sources.push(element.source.name);
  });
  return sources;
};

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(DataTable), {
      value: _ctx.campaigns,
      expandedRows: expandedRows.value,
      "onUpdate:expandedRows": _cache[0] || (_cache[0] = ($event: any) => ((expandedRows).value = $event)),
      class: _normalizeClass([[
      _ctx.campaigns && _ctx.campaigns.length == 0 ? 'empty-table' : '',
      _ctx.isActiveFirst ? 'active-first' : '',
    ], "scroll-table-y main-table scrollbar-custom"]),
      stripedRows: "",
      onSort: sortTable,
      removableSort: "",
      scrollable: "",
      loading: _ctx.isLoading,
      dataKey: "id",
      columnResizeMode: "expand"
    }, {
      expansion: _withCtx((slotProps) => [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_unref(DataTable), {
            value: slotProps.data.campaign_segments,
            class: "sub-table"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Column), {
                field: "sname",
                header: "Название сегмента",
                style: {"min-width":"164px"}
              }, {
                body: _withCtx((slotPropsSegment) => [
                  _createVNode(_component_RouterLink, {
                    to: {
                  name: 'segment',
                  params: { id: slotPropsSegment.data.segment.id },
                }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(slotPropsSegment.data.segment.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _: 1
              }),
              _createVNode(_unref(Column), {
                field: "rich",
                header: "Ожидаемый охват",
                style: {"min-width":"130px"}
              }, {
                body: _withCtx((slotPropsSegment) => [
                  (slotPropsSegment.data.segment.rich)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_unref(formatNumber)(slotPropsSegment.data.segment.rich.rich)), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_unref(Column), {
                field: "platform",
                header: "Рекламная площадка",
                style: {"min-width":"175px"}
              }, {
                body: _withCtx((slotPropsSegment) => [
                  _createVNode(PlatformChip, {
                    "icon-class": slotPropsSegment.data.ads_cabinet.source_slug
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(slotPropsSegment.data.ads_cabinet.source.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["icon-class"])
                ]),
                _: 1
              }),
              _createVNode(_unref(Column), {
                field: "state",
                header: "Статус"
              }, {
                body: _withCtx((slotPropsSegment) => [
                  (_openBlock(), _createElementBlock("svg", {
                    class: _normalizeClass(slotPropsSegment.data.state),
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "8",
                    height: "8",
                    viewBox: "0 0 8 8",
                    fill: "none"
                  }, _hoisted_14, 2)),
                  _createTextVNode(" " + _toDisplayString(_unref(campaignsDictionariesStore).statesSegmentsMap.get(
                  slotPropsSegment.data.state
                )?.name), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(Column), {
                field: "is_segment_auto_renewable",
                header: "Автопродление"
              }, {
                body: _withCtx((slotProps) => [
                  (slotProps.data.is_segment_auto_renewable)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Да"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_16, "Нет"))
                ]),
                _: 2
              }, 1024),
              _createVNode(_unref(Column), {
                field: "ctime",
                header: "Дата создания",
                sortable: "",
                style: {"max-width":"153px"}
              }, {
                body: _withCtx((slotPropsSegment) => [
                  _createTextVNode(_toDisplayString(_unref(convertDateFromUTC)(slotPropsSegment.data.ctime)), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(Column), {
                field: "mtime",
                header: "Дата обновления",
                sortable: "",
                style: {"max-width":"173px"}
              }, {
                body: _withCtx((slotPropsSegment) => [
                  _createTextVNode(_toDisplayString(_unref(convertDateFromUTC)(slotPropsSegment.data.mtime)), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(Column), {
                frozen: "",
                alignFrozen: "right"
              }, {
                body: _withCtx((slotProps) => [
                  _createElementVNode("div", {
                    onClick: (event) => toggleSegments(slotProps.data.id, event),
                    "aria-haspopup": "true",
                    "aria-controls": "overlay_menu",
                    class: "button-menu"
                  }, _hoisted_19, 8, _hoisted_17)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["value"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(Column), {
          expander: "",
          style: {"min-width":"52px","max-width":"52px"}
        }),
        _createVNode(_unref(Column), {
          field: "number",
          header: "№",
          style: {"min-width":"44px"}
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(_ctx.rowsCount + slotProps.index + 1), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "name",
          header: "Название РК",
          sortable: "",
          style: {"min-width":"120px"}
        }, {
          body: _withCtx((slotProps) => [
            _createVNode(_component_RouterLink, {
              to: { name: 'campaign', params: { id: slotProps.data.id } }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(slotProps.data.name), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "period",
          header: "Период",
          style: {"max-width":"153px"}
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(_unref(convertDateFromISOWithShortYear)(slotProps.data.start_date)) + " - " + _toDisplayString(_unref(convertDateFromISOWithShortYear)(slotProps.data.end_date)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "brand",
          header: "Бренд"
        }, {
          body: _withCtx((slotProps) => [
            (slotProps.data.brand)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(slotProps.data.brand.brand_name), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_2, "-"))
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "cuser__lname",
          header: "Пользователь",
          sortable: "",
          style: {"max-width":"150px"}
        }, {
          body: _withCtx((slotProps) => [
            (slotProps.data.cuser)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(getUserName)(slotProps.data.cuser)), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_4, "-"))
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "state",
          header: "Статус",
          style: {"max-width":"150px"}
        }, {
          body: _withCtx((slotProps) => [
            (_openBlock(), _createElementBlock("svg", {
              class: _normalizeClass(slotProps.data.state),
              xmlns: "http://www.w3.org/2000/svg",
              width: "8",
              height: "8",
              viewBox: "0 0 8 8",
              fill: "none"
            }, _hoisted_6, 2)),
            _createTextVNode(" " + _toDisplayString(_unref(campaignsDictionariesStore).statesMap.get(slotProps.data.state)?.name), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "ctime",
          header: "Дата создания",
          sortable: "",
          style: {"min-width":"153px"}
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(_unref(convertDateFromUTC)(slotProps.data.ctime)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "mtime",
          header: "Дата обновления",
          sortable: "",
          style: {"min-width":"173px","max-width":"173px"}
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(_unref(convertDateFromUTC)(slotProps.data.mtime)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), { header: "Источники кампании" }, {
          body: _withCtx((slotProps) => [
            _createVNode(ListWithTooltips, {
              slotProps: getSources(slotProps.data),
              items: "patterns",
              "item-key": "none",
              "item-value": "none"
            }, null, 8, ["slotProps"])
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          frozen: "",
          alignFrozen: "right"
        }, {
          body: _withCtx((slotProps) => [
            _createElementVNode("div", {
              onClick: (event) => toggle(slotProps.data.id, event),
              "aria-haspopup": "true",
              "aria-controls": "overlay_menu",
              class: "button-menu"
            }, _hoisted_9, 8, _hoisted_7)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "expandedRows", "class", "loading"]),
    _createVNode(_unref(Menu), {
      ref_key: "menu",
      ref: menu,
      id: "overlay_menu",
      model: filteredItems.value,
      popup: true
    }, null, 8, ["model"]),
    _createVNode(_unref(Menu), {
      ref_key: "menuSegments",
      ref: menuSegments,
      id: "overlay_menu",
      model: filteredSegmentsItems.value,
      popup: true
    }, null, 8, ["model"]),
    _createVNode(DeleteConfirmDialog, {
      "deleted-name": "кампанию",
      visible: confirmVisible.value.delete,
      blocked: blockedButton.value.delete,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (confirmVisible.value.delete = false)),
      onDelete: deleteCampaign
    }, null, 8, ["visible", "blocked"]),
    _createVNode(ArchiveConfirmDialog, {
      "archived-name": "рекламную кампанию",
      visible: confirmVisible.value.archive,
      blocked: blockedButton.value.archive,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (confirmVisible.value.archive = false)),
      onArchive: archiveCampaign
    }, null, 8, ["visible", "blocked"]),
    _createVNode(UsersHistoryDialog, {
      entity: _unref(modifiedEntity),
      object_id: _unref(modifiedId),
      visible: confirmVisible.value.history,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (confirmVisible.value.history = false))
    }, null, 8, ["entity", "object_id", "visible"])
  ], 64))
}
}

})